/*
   Config files for the environment.
*/
import firebase from 'firebase/app'
import 'firebase/functions'

// const serverLoc = 'http://localhost:5001/samanthas-art/us-central1/app/'
const serverBase = 'localhost:8080'
const serverLoc = 'http://localhost:8080/'
const emailDomain = 'addtothestory.com'

const firebaseConfig = {
  apiKey: 'AIzaSyAvKs3J8aXI0Z5Jf5gauVWGKIHHvtqml78',
  authDomain: 'addtothestory2.firebaseapp.com',
  databaseURL: 'https://addtothestory2.firebaseio.com',
  projectId: 'addtothestory2',
  storageBucket: 'addtothestory2.appspot.com',
  messagingSenderId: '950217935106',
  appId: '1:950217935106:web:d7cb77733b2f17ff199a1b',
  measurementId: 'G-5DZCZEEDM7'
}

const recaptchaSiteKey = '6LcvcPgUAAAAAAUwsvjCzHg7FutlfSc_R0MFDghy'

let theFunctions = null
function getFunctions () {
  if (!theFunctions) {
    theFunctions = firebase.functions()
    if (process.env.NODE_ENV === 'development') {
      console.log('IN DEVELOPMENT')
      theFunctions.useFunctionsEmulator('http://localhost:5001')
    }
  }
  return theFunctions
}

export default {
  analyticsID: firebaseConfig.measurementId, // Production
  type: 'dev',
  serverBase: serverBase,
  serverLoc: serverLoc,
  firebaseConfig: firebaseConfig,
  recaptchaSiteKey: recaptchaSiteKey,
  getFunctions: getFunctions,
  emailDomain: emailDomain
}
